export default function AboutSection() {
  return (
    <section className="relative w-full py-16 md:py-20 bg-background-50 overflow-hidden">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-3/5">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-snug">
              Why Spreadsheets Matter
              <br />
              for Smart Shopping
              <br />
              Decisions
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed max-w-lg text-sm md:text-base">
              A well-organized <strong>LitBuy spreadsheet</strong> transforms how you compare prices, track purchases, and discover the best deals. We&apos;ve curated resources that help thousands of smart shoppers make informed buying decisions every day.
            </p>

            <div className="mt-10 grid grid-cols-3 gap-6 md:gap-8">
              <div className="border-r border-background-200/70 pr-4">
                <p className="text-3xl md:text-4xl font-bold text-primary-500">14+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Product Categories</p>
              </div>
              <div className="border-r border-background-200/70 pr-4">
                <p className="text-3xl md:text-4xl font-bold text-primary-500">500+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Curated Items</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-bold text-primary-500">100%</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Shopping Guide</p>
              </div>
            </div>
          </div>

          <div className="lg:w-2/5 relative">
            <div className="grid grid-cols-2 gap-3">
              <div className="aspect-square rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20sneakers%20in%20warm%20camel%20tone%20on%20a%20clean%20surface%20with%20soft%20natural%20light%2C%20editorial%20product%20photography%20with%20cream%20background%2C%20single%20product%20focus%20with%20gentle%20shadows&width=400&height=400&seq=about-cat-shoes-07&orientation=squarish"
                  alt="Shoes category"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="aspect-square rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cozy%20oatmeal%20colored%20hoodie%20folded%20on%20a%20wooden%20surface%20with%20warm%20sunlight%2C%20minimalist%20fashion%20photography%20with%20neutral%20backdrop%2C%20single%20item%20focus%20with%20texture%20detail&width=400&height=400&seq=about-cat-hoodies-07&orientation=squarish"
                  alt="Hoodies category"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="aspect-square rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Premium%20white%20cotton%20t-shirt%20neatly%20folded%20on%20a%20linen%20surface%2C%20soft%20morning%20light%20with%20gentle%20highlights%2C%20clean%20minimalist%20product%20photography%2C%20warm%20cream%20background&width=400&height=400&seq=about-cat-tshirts-07&orientation=squarish"
                  alt="T-Shirts category"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="aspect-square rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylish%20olive%20green%20bomber%20jacket%20on%20a%20minimalist%20hanger%2C%20soft%20studio%20lighting%20creating%20subtle%20shadows%2C%20contemporary%20fashion%20editorial%20with%20clean%20backdrop&width=400&height=400&seq=about-cat-jackets-07&orientation=squarish"
                  alt="Jackets category"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}